// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendors" + "-" + "d454f390724db7ce86b2" + ".js";
};